import Avatar from './Avatar';

// export types
export type { AvatarProps } from './Avatar';

// export components
export { Avatar };
export default Avatar;
